// The letters in a fan's bubble (founder, 1.5.2): the first letter of the first
// and the last word — "Ana Lopez" → "AL" — or one letter for a one-word name.
// Apple and Google hand us the full name, so most fans get two. Counted by
// glyph, so an emoji or an accented letter is never cut in half.
export function initialsOf(name: string): string {
  const words = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (!words.length) return "";
  const first = Array.from(words[0])[0] || "";
  const last = words.length > 1 ? Array.from(words[words.length - 1])[0] || "" : "";
  return (first + last).toUpperCase();
}
